import { buildRecordFromKeyList } from "../build-record-from-key-list";
import { HEAT_CARRIER_KEY_LIST } from "./heat-carrier-key";
export const EMPTY_HEAT_MIX_SWITCH_PARAMETERS = {
    targetPercentageByCarrier: buildRecordFromKeyList(HEAT_CARRIER_KEY_LIST, () => 0),
};
